import { createAction } from 'redux-actions-helpers'
import {
  AchievementItemType,
  NewAchievementsItemType,
  ProfileType,
  ReferralLink,
  UpdateProfileType,
} from './types'
import { CertificateItemType } from '../../components/AwardsEditBlock/types'

export const signIn = createAction(
  '@@profile/SIGN_IN',
  (code: string, redirect_uri: string, came_from: string): any => ({
    code,
    redirect_uri,
    came_from,
  })
)

export const signInSuccess = createAction('@@profile/SIGN_IN_SUCCESS')

export const signInFailure = createAction(
  '@@profile/SIGN_IN_FAILURE',
  (error: string): any => ({ error })
)

export const signOut = createAction('@@profile/SIGN_OUT')

export const signOutSuccess = createAction('@@profile/SIGN_OUT_SUCCESS')

export const signOutFailure = createAction(
  '@@profile/SIGN_OUT_FAILURE',
  (error: string): any => ({ error })
)

export const fetchProfile = createAction('@@profile/FETCH_PROFILE')

export const fetchProfileSuccess = createAction(
  '@@profile/FETCH_PROFILE_SUCCESS',
  (result: ProfileType): any => ({ result })
)

export const fetchProfileFailure = createAction(
  '@@profile/FETCH_PROFILE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchNewAchievements = createAction(
  '@@profile/FETCH_NEW_ACHIEVEMENTS'
)

export const fetchNewAchievementsSuccess = createAction(
  '@@profile/FETCH_NEW_ACHIEVEMENTS_SUCCESS',
  (result: NewAchievementsItemType[]): any => ({ result })
)

export const fetchNewAchievementsFailure = createAction(
  '@@profile/FETCH_NEW_ACHIEVEMENTS_FAILURE',
  (error: string): any => ({ error })
)

export const markViewedAchievement = createAction(
  '@@profile/MARK_VIEWED_ACHIEVEMENT',
  (id: string): any => ({ id })
)

export const markViewedAchievementSuccess = createAction(
  '@@profile/MARK_VIEWED_ACHIEVEMENT_SUCCESS'
)

export const markViewedAchievementFailure = createAction(
  '@@profile/MARK_VIEWED_ACHIEVEMENT_FAILURE',
  (error: string): any => ({ error })
)

export const setSelectedAchievement = createAction(
  '@@profile/SET_SELECTED_ACHIEVEMENT',
  (achieve: AchievementItemType | null): any => ({ achieve })
)

export const checkFirstModuleComplete = createAction(
  '@@profile/CHECK_FIRST_MODULE_COMPLETE',
  (id: string): any => ({ id })
)

export const checkFirstModuleCompleteSuccess = createAction(
  '@@profile/CHECK_FIRST_MODULE_COMPLETE_SUCCESS',
  (result: boolean): any => ({ result })
)

export const checkFirstModuleCompleteFailure = createAction(
  '@@profile/CHECK_FIRST_MODULE_COMPLETE_FAILURE'
)

export const saveProfile = createAction(
  '@@profile/SAVE_PROFILE',
  (data: UpdateProfileType): any => ({ data })
)

export const saveProfileSuccess = createAction('@@profile/SAVE_PROFILE_SUCCESS')

export const saveProfileFailure = createAction(
  '@@profile/SAVE_PROFILE_FAILURE',
  (error: string): any => ({ error })
)

export const uploadPhoto = createAction(
  '@@profile/UPLOAD_PHOTO',
  (photo: File): any => ({ photo })
)

export const uploadPhotoSuccess = createAction('@@profile/UPLOAD_PHOTO_SUCCESS')

export const uploadPhotoFailure = createAction(
  '@@profile/UPLOAD_PHOTO_FAILURE',
  (error: string): any => ({ error })
)

export const removePhoto = createAction('@@profile/REMOVE_PHOTO')

export const removePhotoSuccess = createAction('@@profile/REMOVE_PHOTO_SUCCESS')

export const removePhotoFailure = createAction(
  '@@profile/REMOVE_PHOTO_FAILURE',
  (error: string): any => ({ error })
)

export const fetchReferralLink = createAction(
  '@@profile/FETCH_REFERRAL_LINK',
  (
    typeReferral: string,
    redirect_url: string,
    is_reverse: string,
    connection_type?: string
  ): any => ({
    typeReferral,
    redirect_url,
    is_reverse,
    connection_type,
  })
)

export const fetchReferralLinkSuccess = createAction(
  '@@profile/FETCH_REFERRAL_LINK_SUCCESS',
  (result: ReferralLink): any => ({
    result,
  })
)

export const fetchReferralLinkFailure = createAction(
  '@@profile/FETCH_REFERRAL_LINK_FAILURE',
  (error: string): any => ({ error })
)

export const sendParentInvite = createAction(
  '@@profile/SEND_PARENT_INVITE',
  (parent: 'father' | 'mother', email: string): any => ({ parent, email })
)

export const sendParentInviteSuccess = createAction(
  '@@profile/SEND_PARENT_INVITE_SUCCESS'
)

export const sendParentInviteFailure = createAction(
  '@@profile/SEND_PARENT_INVITE_FAILURE',
  (error: string): any => ({ error })
)

export const sendParentInviteDestroy = createAction(
  '@@profile/SEND_PARENT_INVITE_DESTROY'
)

export const sendEmailInvite = createAction(
  '@@profile/SEND_EMAIL_INVITE',
  (code: string, email: string, text: string): any => ({ code, email, text })
)

export const sendEmailInviteSuccess = createAction(
  '@@profile/SEND_EMAIL_INVITE_SUCCESS'
)

export const sendEmailInviteFailure = createAction(
  '@@profile/SEND_EMAIL_INVITE_FAILURE',
  (error: string): any => ({ error })
)

export const uploadAchievementScreenshot = createAction(
  '@@profile/UPLOAD_ACHIEVEMENT_SCREENSHOT',
  (achievementId: string, image: File): any => ({ achievementId, image })
)

export const uploadAchievementScreenshotSuccess = createAction(
  '@@profile/UPLOAD_ACHIEVEMENT_SCREENSHOT_SUCCESS'
)

export const uploadAchievementScreenshotFailure = createAction(
  '@@profile/UPLOAD_ACHIEVEMENT_SCREENSHOT_FAILURE',
  (error: string): any => ({ error })
)

export const shareAchievementScreenshot = createAction(
  '@@profile/SHARE_ACHIEVEMENT_SCREENSHOT',
  (achievementId: string, image: File): any => ({ achievementId, image })
)

export const shareAchievementScreenshotSuccess = createAction(
  '@@profile/SHARE_ACHIEVEMENT_SCREENSHOT_SUCCESS',
  (image: string): any => ({ image })
)

export const shareAchievementScreenshotFailure = createAction(
  '@@profile/SHARE_ACHIEVEMENT_SCREENSHOT_FAILURE',
  (error: string): any => ({ error })
)

export const clearReferralLink = createAction('@@profile/CLEAR_REFERRAL_LINK')

export const clearError = createAction('@@profile/CLEAR_ERROR')

export const closeModalQuestionnaire = createAction(
  '@@profile/CLOSE_MODAL_QUESTIONNAIRE'
)

export const setCurrentCourseTitle = createAction(
  '@@profile/SET_CURRENT_COURSE_TITLE',
  (title: string): any => ({ title })
)

export const setViewedContestWork = createAction(
  '@@profile/SET_VIEWED_CONTEST_WORK',
  (id: string): any => ({ id })
)

export const changeProfileRole = createAction(
  '@@profile/CHANGE_PROFILE_ROLE',
  (typeRole: 'teacher' | 'student'): any => ({ typeRole })
)

export const changeProfileRoleSuccess = createAction(
  '@@profile/CHANGE_PROFILE_ROLE_SUCCESS'
)

export const changeProfileRoleFailure = createAction(
  '@@profile/CHANGE_PROFILE_ROLE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCertificates = createAction('@@profile/FETCH_CERTIFICATES')

export const fetchCertificatesSuccess = createAction(
  '@@profile/FETCH_CERTIFICATES_SUCCESS',
  (result: CertificateItemType[]): any => ({ result })
)

export const fetchCertificatesFailure = createAction(
  '@@profile/FETCH_CERTIFICATES_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@profile/DESTROY')
